import script from "./password-strength.vue?vue&type=script&setup=true&lang=js"
export * from "./password-strength.vue?vue&type=script&setup=true&lang=js"

import "./password-strength.vue?vue&type=style&index=0&id=470385ac&lang=scss"

const __exports__ = script;

export default __exports__